import { TIMELINE, SAVOIR_FAIRE, SAVOIR_ETRE, DIFFERENTIATORS } from "../data/content";
import { SectionLabel, Reveal } from "../components/ui-bits";

export default function Parcours() {
  return (
    <div data-testid="page-parcours" className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionLabel>Parcours & légitimité</SectionLabel>
          <h1 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-white leading-[1.05]">
            25 ans à diriger<br />des transformations.
          </h1>
          <p className="mt-6 text-lg text-slate-400 max-w-2xl">
            De l'industrie lourde aux établissements de santé : des environnements exigeants, sous pression, où il faut décider et délivrer.
          </p>
        </Reveal>

        {/* Timeline */}
        <div className="mt-16 relative">
          <div className="absolute left-0 md:left-[140px] top-2 bottom-2 w-px bg-slate-800" />
          <div className="space-y-12">
            {TIMELINE.map((t, i) => (
              <Reveal key={t.period} delay={i * 0.05}>
                <div data-testid="timeline-item" className="relative md:grid md:grid-cols-[140px_1fr] gap-10 pl-8 md:pl-0">
                  <div className="md:text-right md:pr-10">
                    <span className="font-heading text-sm font-medium text-blue-500">{t.period}</span>
                  </div>
                  <div className="absolute left-[-4px] md:left-[136px] top-1.5 w-2.5 h-2.5 rounded-full bg-blue-500 ring-4 ring-slate-950" />
                  <div className="mt-3 md:mt-0">
                    <div className="flex flex-wrap items-center gap-3">
                      <h3 className="font-heading text-xl font-medium text-white">{t.org}</h3>
                      <span className="text-[11px] uppercase tracking-wider text-slate-400 bg-slate-800/60 border border-slate-700 px-2.5 py-1 rounded-full">{t.sector}</span>
                    </div>
                    <p className="mt-2 text-blue-300/80 text-sm font-medium">{t.role}</p>
                    <p className="mt-2 text-slate-400 leading-relaxed">{t.detail}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Compétences */}
        <Reveal className="mt-28">
          <SectionLabel>Ce que je sais faire</SectionLabel>
          <h2 className="mt-6 font-heading text-3xl md:text-4xl font-medium text-white">Savoir-faire & savoir-être.</h2>
        </Reveal>
        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <Reveal>
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-8 h-full">
              <h3 className="font-heading text-lg font-medium text-white mb-6">Savoir-faire opérationnels</h3>
              <div className="flex flex-wrap gap-2.5">
                {SAVOIR_FAIRE.map((s) => (
                  <span key={s} data-testid="savoir-faire-tag" className="text-sm text-slate-300 bg-blue-600/10 border border-blue-500/20 px-3.5 py-2 rounded-lg">{s}</span>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-8 h-full">
              <h3 className="font-heading text-lg font-medium text-white mb-6">Savoir-être</h3>
              <div className="flex flex-wrap gap-2.5">
                {SAVOIR_ETRE.map((s) => (
                  <span key={s} data-testid="savoir-etre-tag" className="text-sm text-slate-300 bg-slate-800/60 border border-slate-700 px-3.5 py-2 rounded-lg">{s}</span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>

        {/* Différenciation */}
        <Reveal className="mt-28">
          <SectionLabel>Ce qui me rend différent</SectionLabel>
          <h2 className="mt-6 font-heading text-3xl md:text-4xl font-medium text-white">Quatre convictions opérationnelles.</h2>
        </Reveal>
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {DIFFERENTIATORS.map((d, i) => (
            <Reveal key={d.num} delay={(i % 2) * 0.1}>
              <div data-testid="differentiator-card" className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 h-full hover:border-blue-500/30 transition-colors">
                <span className="font-heading text-2xl text-blue-500/60">{d.num}</span>
                <h3 className="mt-3 font-heading text-xl font-medium text-white">{d.title}</h3>
                <p className="mt-3 text-slate-400 leading-relaxed">{d.text}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {d.tags.map((tag) => (
                    <span key={tag} className="text-xs text-slate-500 border border-slate-700/70 px-2.5 py-1 rounded-full">{tag}</span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
